// React libraries
import React, { useEffect, useState } from "react";
// Custom Styles
import { useStyles } from "./PickPackIgnoreItemsPageStyles";
// Material-UI Core
import { Grid, Button } from "@mui/material";
import BlueGradientHeader from "../BlueGradientHeader";
import PageWrapper from "../PageWrapper";
import GreyButton from "../GreyButton";
import ScanContentBar from "../ScanContentBar";
import { Edit as EditIcon } from "@mui/icons-material";
export const PickPackIgnoreItemsPage = (props) => {
    const classes = useStyles(props);
    const { previewWidth, previewHeight, data, scanContentBarText } = props;
    const [listData, setListData] = useState(data);
    useEffect(() => {
        setListData(data);
    }, [data]);
    return (React.createElement(PageWrapper, { previewHeight: previewHeight, previewWidth: previewWidth },
        React.createElement(Grid, { container: true },
            React.createElement(Grid, { item: true, md: 12 },
                React.createElement(BlueGradientHeader, { type: "smallWithSub", showScanner: true, previewHeight: previewHeight },
                    React.createElement("p", null, "Pick and Pack"),
                    React.createElement("sub", null,
                        "Bin Location - ",
                        React.createElement("b", null, "05-G01-R01-P02")))),
            React.createElement(Grid, { item: true, md: 12, className: classes.whiteContentTopRadius, style: { height: previewHeight - 90 - 50 + 10 } },
                React.createElement(Grid, { container: true },
                    React.createElement(Grid, { item: true, md: 12 },
                        React.createElement(ScanContentBar, { text: scanContentBarText || PickPackIgnoreItemsPage.defaultProps.scanContentBarText })),
                    React.createElement(Grid, { item: true, md: 12, className: classes.listOrderItemsDiv, style: { height: previewHeight - 90 - 50 - 40 + 10 } },
                        React.createElement(Grid, { container: true, className: classes.listOrderItemsContainer }, listData === null || listData === void 0 ? void 0 : listData.map((pickPackItem) => (React.createElement(Button, { className: classes.listOrderItemsButton },
                            React.createElement(Grid, { item: true, md: 12 },
                                React.createElement(Grid, { container: true },
                                    React.createElement(Grid, { item: true, md: 10 },
                                        React.createElement(Grid, { container: true },
                                            React.createElement(Grid, { item: true, md: 12 },
                                                React.createElement(Grid, { container: true },
                                                    React.createElement(Grid, { className: classes.listOrderItemsButtonTitle, item: true, md: 6 }, "Item"),
                                                    React.createElement(Grid, { className: classes.listOrderItemsButtonTitle, item: true, md: 6 }, "Batch"))),
                                            React.createElement(Grid, { item: true, md: 12 },
                                                React.createElement(Grid, { container: true },
                                                    React.createElement(Grid, { className: classes.listOrderItemsButtonLeftContent, item: true, md: 6 }, pickPackItem.item),
                                                    React.createElement(Grid, { className: classes.listOrderItemsButtonLeftContent, item: true, md: 6 }, pickPackItem.batch))),
                                            React.createElement(Grid, { className: classes.listOrderItemsButtonTitle, item: true, md: 12 }, "Description"),
                                            React.createElement(Grid, { className: classes.listOrderItemsButtonLeftContent, item: true, md: 12 }, pickPackItem.description))),
                                    React.createElement(Grid, { container: true, item: true, md: 2, alignItems: "center", justifyContent: "flex-end", style: { color: "#2d9dd5" } },
                                        React.createElement(EditIcon, null))))))))))),
            React.createElement(Grid, { item: true, md: 6 },
                React.createElement(GreyButton, { onClick: () => { }, type: "left" }, "Back")),
            React.createElement(Grid, { item: true, md: 6 },
                React.createElement(GreyButton, { onClick: () => { }, type: "right" }, "Next")))));
};
PickPackIgnoreItemsPage.defaultProps = {
    scanContentBarText: "Scan Item"
};
export default React.memo(PickPackIgnoreItemsPage);
